import React from "react";
import {
  textareaWrapper,
  errorBorder,
  textareaElement,
  textareaLabelElement,
  errorTextElement
} from "./textarea.module.css";

/**
 * type is for the textarea  type itself
 * textarea Type is to choose between "textarea" or 'textarea '
 * error is the error state of the textField
 * icon should take icons in a html elements
 * errorText holds the error message if you want to show one
 *
 */
const Textarea = ({
  onClick,
  type,
  value,
  className,
  onChange,
  rows,
  disabled,
  name,
  required,
  errorText,
  textareaText,
  textareaLabel,
  ...restProps
}) => {
  return (
    <div className={`${textareaWrapper}`}>
      <label className={`className ${textareaLabelElement}`}>
        {textareaLabel}
      </label>
      <textarea
        className={`${className} ${textareaElement} {error && ${errorBorder} } `}
        rows={rows}
        onChange={onChange}
        value={value}
        name={name}
        required={required}
        {...restProps}
      >
        {textareaText}
      </textarea>
      <span className={errorTextElement}>{errorText}</span>
    </div>
  );
};

export { Textarea };
